(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-mega-menu"] && !Shopify.designMode) return;
  try {
    // ---------- parsing robusto di custom.fonte_proteica (stessa logica di sg-product-search) ----------
  function sgFonteValues(f) {
    if (!f) return [];
    if (Array.isArray(f)) return f.filter(Boolean);
    var s = String(f).trim();
    if (!s) return [];
    if (s.indexOf(',') > -1) return s.split(',').map((x) => x.trim()).filter(Boolean);
    return [s];
  }
  function sgEsc(s) {
    return (s || '').toString().replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }
  // Aggiunge il prefisso lingua (/en/, /de/) solo se l'URL non ce l'ha gia'.
  function sgRootify(u) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!u || u.charAt(0) !== '/' || root === '/') return u;
    if (u.indexOf(root) === 0) return u;
    return root + u.slice(1);
  }
  function sgCardHTML(p, cardClass, mediaClass, nameClass) {
    var img = p.image ? '<img loading="lazy" src="' + sgEsc(p.image) + '" alt="' + sgEsc(p.title) + '">' : '';
    return '<a href="' + sgEsc(sgRootify(p.url)) + '" class="' + cardClass + '"><span class="' + mediaClass + '">' + img + '</span><span class="' + nameClass + '">' + sgEsc(p.title) + '</span></a>';
  }
  // Ordine: 1) singolo tag corrispondente disponibili, 2) singolo tag
  // corrispondente non disponibili, 3) tag multipli con match (non gift
  // card), 4) tag multipli con match che SONO gift card — sempre in
  // fondo (la gift card compare ovunque abbia un match, ma per ultima).
  function sgPickForLine(products, tag, limit) {
    var singleAvail = products.filter((p) => {
      var v = sgFonteValues(p.fonte);
      return v.length === 1 && v[0] === tag && p.available;
    });
    var singleUnavail = products.filter((p) => {
      var v = sgFonteValues(p.fonte);
      return v.length === 1 && v[0] === tag && !p.available;
    });
    var multiNonGift = products.filter((p) => {
      var v = sgFonteValues(p.fonte);
      return v.length > 1 && v.indexOf(tag) > -1 && !p.giftCard;
    });
    var multiGift = products.filter((p) => {
      var v = sgFonteValues(p.fonte);
      return v.length > 1 && v.indexOf(tag) > -1 && p.giftCard;
    });
    return singleAvail.concat(singleUnavail, multiNonGift, multiGift).slice(0, limit);
  }
  function sgPickMulti(products, limit) {
    var multiNonGift = products.filter((p) => !p.giftCard && sgFonteValues(p.fonte).length > 1);
    var multiGift = products.filter((p) => p.giftCard && sgFonteValues(p.fonte).length > 1);
    return multiNonGift.concat(multiGift).slice(0, limit);
  }

  class SgShopMenu extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.sg-sm__tab'));
      this.panels = Array.from(this.querySelectorAll('.sg-sm__panel'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.target));
      });
      this.querySelectorAll('.sg-sm__arrow-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const track = this.querySelector('#' + btn.dataset.track);
          if (!track) return;
          const dir = btn.classList.contains('sg-sm__arrow-btn--next') ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.75, behavior: 'smooth' });
        });
      });
      this.populate();
    }
    populate() {
      var instance = this.dataset.instance;
      var dataEl = document.getElementById('sg-sm-data-' + instance);
      if (!dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent || '{}');
      } catch (e) {
        return;
      }
      var limit = 24;
      var pool = data.catalogo || [];
      var lines = [
        { key: 'insetti', tag: 'Proteine da Insetti' },
        { key: 'lievito', tag: 'Proteine del Lievito' },
        { key: 'cozze', tag: 'Cozze' },
      ];
      lines.forEach((line) => {
        var track = this.querySelector('#sg-sm-track-' + instance + '-' + line.key);
        if (!track) return;
        var picked = sgPickForLine(pool, line.tag, limit);
        track.innerHTML = picked.map((p) => sgCardHTML(p, 'sg-sm__card', 'sg-sm__card-media', 'sg-sm__card-name')).join('');
      });
      var trackAll = this.querySelector('#sg-sm-track-' + instance + '-provatutto');
      if (trackAll) {
        var pickedAll = sgPickMulti(data.catalogo || [], limit);
        trackAll.innerHTML = pickedAll.map((p) => sgCardHTML(p, 'sg-sm__card', 'sg-sm__card-media', 'sg-sm__card-name')).join('');
      }
    }
    select(id) {
      this.tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.target === id)));
      this.panels.forEach((p) => {
        p.hidden = p.id !== id;
      });
    }
  }
  if (!customElements.get('sg-shop-menu')) customElements.define('sg-shop-menu', SgShopMenu);
  } catch(e) { console.error(e); }
})();

})();
